import { HTMLAttributes } from 'react';
import { MarketActivityIndicator } from '@market/react';
import styles from 'typescript/components/empty_state_with_loading.module.scss';

export const EMPTY_STATE_TEST_ID = 'empty-state-test-id';

interface EmptyStateWithLoadingProps extends HTMLAttributes<HTMLDivElement> {
  showLoading?: boolean;
  description?: string;
}

const EmptyStateWithLoading = ({
  className,
  showLoading = false,
  description,
}: EmptyStateWithLoadingProps) => {
  return (
    <div
      data-testid={EMPTY_STATE_TEST_ID}
      className={`${styles.container} ${className}`}
    >
      {showLoading ? <MarketActivityIndicator /> : <p>{description}</p>}
    </div>
  );
};

export default EmptyStateWithLoading;
